import React from 'react';
import { useFormikContext } from 'formik';
import { Slider, Label } from '@futurefamily/ef-components';
import * as config from 'config';

function DownpaymentSlider (props) {
  const { values } = useFormikContext();

  const maxDownPayment = values.cost - config.LOAN_MINIMUM;
  const partiallyFinanceable = values.cost >= config.LOAN_MINIMUM + config.DOWNPAYMENT_MINIMUM;

  return (
    <>
      {partiallyFinanceable
        ? <Label className="mb-3">Select the ideal term and down payment to see your monthly payment amount</Label>
        : <Label className="mb-3">Select the ideal term for your financing options</Label>
      }

      {partiallyFinanceable && (
        <Slider
          {...props}
          min={config.DOWNPAYMENT_MINIMUM}
          max={maxDownPayment}
          step={100}
          name="downpayment"
        />
      )}
    </>
  );
}

export default DownpaymentSlider;
